import axios from 'axios'
import { apiEndpoint } from 'app/config'
import { v4 as uuid } from 'uuid'

import { getOrganizationDomainFromUrl } from 'helpers/urlHelper'

export default axios.create({
  baseURL: apiEndpoint,
  headers: { 'X-Request-Token': uuid() },
})

export const getShortenUrl = url =>
  axios.post('https://prohab.it/prod/', {
    cdn_prefix: 'prohab.it',
    url_long: url,
  })

export const getManifestFromServer = async () => {
  const origin = (location && location.origin) || 'https://mabblytribe.prohabits.com'
  const res = await axios.get(`${origin}/manifest.json`)
  return res
}

export const getOrganizationLanguage = async () => {
  const res = await axios.get(
    `${apiEndpoint}/organizations/by-domain/${getOrganizationDomainFromUrl(document.location.hostname)}`
  )
  return res.data
}
